import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Student"],
});

const studentApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getStudent: builder.query({
      query: (parameter) => `/student/${parameter}`,
      providesTags: ["Student"],
    }),
    getAllStudents: builder.query({
      query: () => `/student/all`,
      providesTags: ["Student"],
    }),
    createStudent: builder.mutation({
      query: (values) => ({
        url: "/student/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Student", "Classes"],
    }),
    updateStudent: builder.mutation({
      query: (values) => ({
        url: "/student/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Student", "Classes"],
    }),
    importStudents: builder.mutation({
      query: (values) => ({
        url: "/student/import",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Student", "Classes"],
    }),
    deleteStudent: builder.mutation({
      query: (values) => ({
        url: `/student/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Student", "Classes"],
    }),
    getStudentClassrooms: builder.query({
      query: (values) => `/student/${values.id}/classes`,
      providesTags: ["Student"],
    }),

    addStudentToClassroom: builder.mutation({
      query: (values) => ({
        url: `/classroom/${values.classroom_id}/students/add`,
        method: "PATCH",
        body: values.body,
      }),
      invalidatesTags: ["Student"],
    }),
    removeStudentFromClassroom: builder.mutation({
      query: (values) => ({
        url: `/classroom/${values.classroom_id}/students/remove`,
        method: "PATCH",
        body: values.body,
      }),
      invalidatesTags: ["Classes", "Student"],
    }),
    updateStudentInClassroom: builder.mutation({
      query: ({ classroom_id, student_id, ...body }) => ({
        url: `/classroom/${classroom_id}/students/${student_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Student", "Classes"],
    }),
    graduateStudents: builder.mutation({
      query: (values) => ({
        url: "/student/graduate",
        method: "PATCH",
        body: values,
      }),
      invalidatesTags: ["Classes", "Student"],
    }),
    ungraduateStudents: builder.mutation({
      query: (values) => ({
        url: "/student/ungraduate",
        method: "PATCH",
        body: values,
      }),
      invalidatesTags: ["Classes", "Student"],
    }),
    getGraduatedStudents: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: "/student/graduated",
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Student"],
    }),
  }),
});

export const {
  useCreateStudentMutation,
  useDeleteStudentMutation,
  useGetAllStudentsQuery,
  useGetStudentQuery,
  useUpdateStudentMutation,
  useImportStudentsMutation,
  useAddStudentToClassroomMutation,
  useGetStudentClassroomsQuery,
  useRemoveStudentFromClassroomMutation,
  useUpdateStudentInClassroomMutation,
  useGraduateStudentsMutation,
  useUngraduateStudentsMutation,
  useGetGraduatedStudentsQuery,
} = studentApiSlice;
